import React from "react";
import { Field } from "../onboarding/Field";
import { NUTRI_INFO_STEPS, isVisible } from "../../lib/onboardingSchema";
import "../empieza/empieza.css";

export const NutritionInfoForm = ({ data, setData, testid = "nutri-info-form" }) => (
  <div data-testid={testid}>
    {NUTRI_INFO_STEPS.map((s) => (
      <div key={s.title} style={{ marginBottom: 18 }}>
        <div style={{ color: "var(--qv-red, #E11D2E)", fontSize: 11, letterSpacing: "0.2em", textTransform: "uppercase", fontWeight: 700, marginBottom: 10 }}>{s.title}</div>
        {s.fields.filter((f) => isVisible(f, data, {})).map((f) => (
          <Field key={f.k} f={f} value={data[f.k]} data={data} testid={`${testid}-${f.k}`} onChange={(v) => setData({ ...data, [f.k]: v })} />
        ))}
      </div>
    ))}
  </div>
);
